/* eslint-disable camelcase */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Vue from 'vue';
import Card from 'src/components/Card/Card.vue';
import LineGraph from 'src/components/Graphs/LineGraph.vue';
import { omit } from 'lodash';
import rpc from 'src/api/rpc';
import rowMenuItemShowReservationsList from './rowMenuItemShowReservationsList.vue';
import getDisplayValue from 'src/components/GenericTable/utils/getDisplayValue';
import getValue from 'src/components/GenericTable/utils/getValue';
import ClassMetricGraph from './ClassMetricsGraph.vue';
import GenericTable from 'src/components/GenericTable/GenericTable.vue';
import fullScreenLoading from 'src/utils/fullScreenLoading';
export default Vue.extend({
    components: { Card, LineGraph, rowMenuItemShowReservationsList },
    props: {
        row: { type: Object, default: null, required: true },
        col: { type: Object, default: null, required: true },
        fieldIsClassIdProp: { type: Boolean, default: false },
        class_metric_ids_prop: { type: Array, default: () => null },
        ctx: { type: Object } // GenericTable vm context
    },
    data() {
        return {
            visible: false,
            historyData: [],
            class_metric_ids_data: [],
            overrideValue: null
        };
    },
    computed: {
        cellComputedClasses() {
            let res = [];
            if (this.overridableMetrics.includes(this.col.field))
                res.push('highlighted-value-box');
            if (this.col.conditionalClasses) {
                const cc = this.col.conditionalClasses(this.row, this.col);
                if (cc) {
                    res = [...res, ...cc];
                }
            }
            return res;
        },
        cellComputedStyles() {
            let res = {};
            if (this.col.labelColorMap && this.col.labelColorMap[String(this.value)]) {
                res['background-color'] = this.col.labelColorMap[String(this.value)];
                res['padding'] = '0 6px';
                res['border-radius'] = '5px';
            }
            return res;
        },
        overrideInfo() {
            if (!this.row.overrides)
                return null;
            if (!this.row.overrides[this.col.field])
                return null;
            return this.row.overrides[this.col.field];
        },
        overridableMetrics() { return ['broker_availability_remaining_spots', 'broker_price_per_rules_and_overrides', 'standby_capacity']; },
        displayValue() { return getDisplayValue(this.col, this.row); },
        value() { return getValue(this.col, this.row); }
    },
    watch: {
        value: {
            immediate: true,
            handler(newVal) { this.overrideValue = newVal; }
        }
    },
    methods: {
        applyOverride() {
            return __awaiter(this, void 0, void 0, function* () {
                fullScreenLoading.show({ message: 'Recalculating and resubmitting the classes to the booking engines' });
                const response = yield rpc('ci.apply_override', { override_value: this.overrideValue, metric: this.col.field, id: this.row.id });
                if (response) {
                    this.$store.dispatch('ci.classes/processPartialRefresh', response);
                    this.$q.notify('Override successfully applied');
                    fullScreenLoading.hide();
                }
                return true;
            });
        },
        removeOverride() {
            return __awaiter(this, void 0, void 0, function* () {
                fullScreenLoading.show({ message: 'Recalculating and resubmitting the classes to the booking engines' });
                const response = yield rpc('ci.remove_override', { metric: this.col.field, id: this.row.id });
                if (response) {
                    this.$store.dispatch('ci.classes/processPartialRefresh', response);
                    this.$q.notify('Override successfully removed');
                    fullScreenLoading.hide();
                }
            });
        },
        handleClick() {
            return __awaiter(this, void 0, void 0, function* () {
                this.ctx.dialogComponentPlaceHolder = ClassMetricGraph;
                this.ctx.dialogComponentPlaceHolderProps = omit(this.$props, ['ctx']);
            });
        },
        navigateToClass(classId) {
            this.$store.dispatch('mode/setCurrentMode', {
                component: GenericTable,
                componentProps: {
                    localEntityNameProp: this.ctx.localEntityNameProp || 'ci.classes',
                    startingFilterModelProp: [
                        { field: 'id', predicate: 'equals', value: classId }
                    ]
                }
            });
        }
    }
});
